import {
  Component,
  OnInit,
  AfterViewChecked,
  AfterViewInit,
} from "@angular/core";
import {
  AppToolbarService,
  MenuItem,
} from "@service/app-toolbar/app-toolbar.service";
import { Observable } from "rxjs";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { filter, tap } from "rxjs/operators";

import { ProjectService } from "@service/project.service";
import { TemplateService } from "@service/templates.service";
import { DocumentService } from "@service/documents.service";
import { Events } from "@service/events.service";
import { AuthService } from "@service/auth.service";
import { environment } from "@env/environment";
import { ModalConfirmationDialogService } from "@component/modal-confirmation-dialog/modal-confirmation-dialog.service";
import { JoyrideService } from "ngx-joyride";
import { Subscription } from "rxjs";
import { ModalViewBibtexComponent } from '@component/modal-view-bibtex/modal-view-bibtex.component'
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PlanningService } from "@service/planning.service";

import { select, Store } from "@ngrx/store";
import {
  addMenuItem,
  addAdminUrlMenuItem,
  clearAdminUrlsMenu,
  clearMenu,
  getAllAdminUrlsMenuItems,
  getAllInstitutionUrlsMenuItems,
  getAllMenuItems,
  getIsSuperUser,
  getIsInstitution,
  loadAllMenuItems,
  MenuState,
} from "@app/store";
import { InstitutionService } from "@service/institution.service";
import { Profile } from "@model/Profile";
import { Protocol } from "@model/Protocol";

declare var $: any;

abstract class ItemMenu {
  property: string;
  description: string;
  position: number;
  selected: boolean = false;


  constructor(property: string, description: string, position: number) {
    this.property = property;
    this.description = description;
    this.position = position;
  }

  abstract fetchContent(): void;
}

class PreTextualsMenuItem extends ItemMenu {
  fetchContent() {
    DocumentService.pushProperty(this.property);
  }
}

class TextualsMenuItem extends ItemMenu {
  fetchContent() {
    DocumentService.pushProperty(this.property);
  }
}

class PosTextualsMenuItem extends ItemMenu {
  fetchContent() {
    DocumentService.pushProperty(this.property);
  }
}

const preTextualsTexts = {
  show_capa: "Capa",
  show_thanks: "Agradecimentos",
  show_list_illustration: "Lista de Ilust. (Auto)",
  show_cover_page: "Folha de Rosto",
  show_epigraph: "Epígrafe",
  show_table_list: "Lista de Tabelas (Auto)",
  show_list_abbreviations: "Lista de Abrev. e Siglas",
  show_approval_sheet: "Folha de Aprovação",
  show_resume: "Resumo",
  show_simbol_list: "Lista de Símbolos",
  show_dedication: "Dedicatória",
  show_abstract: "Abstract",
  show_summary: "Sumário (Auto)",
  show_catalog: "Ficha Catalográfica",
  show_french_resume: "Resumo Francês",
  show_spanish_resume: "Resumo Espanhol",
  show_italian_resume: "Resumo Italiano",
  show_chapters: "Seções",
};
const preTextualsTextsPositions = [
  "show_capa",
  "show_cover_page",
  "show_catalog",
  "show_approval_sheet",
  "show_dedication",
  "show_thanks",
  "show_epigraph",
  "show_resume",
  "show_french_resume",
  "show_spanish_resume",
  "show_italian_resume",
  "show_abstract",
  "show_table_list",
  "show_list_illustration",
  "show_list_abbreviations",
  "show_simbol_list",
  "show_summary",
];

const posTextualsTexts = {
  show_reference: "Referências (Auto)",
  show_glossary: "Glossário",
  show_all_appendices: "Apêndices",
  show_all_atachments: "Anexos",
  show_index: "Índice",
  show_identification: "Identificação",
};
const posTextualsTextsPositions = [
  "show_reference",
  "show_glossary",
  "show_all_appendices",
  "show_all_atachments",
  "show_index",
  "show_identification",
];

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
})
export class MenuComponent implements OnInit, AfterViewChecked {
  menuItems$: Observable<MenuItem[]>;
  adminUrls$: Observable<MenuItem[]>;
  institutionUrls$: Observable<MenuItem[]>;
  isSuperUser$: Observable<boolean>;
  isInstitutionAdmin$: Observable<boolean>;

  mainMenuItems: MenuItem[];
  activeMenuItem$: Observable<MenuItem>;

  public menuTexts: string[] = [
    "Planejamento",
    "Desenvolvimento",
    "Configuração",
    "Edição de Texto",
  ];

  public preTextualsMenuItems: ItemMenu[] = [];
  public posTextualsMenuItems: ItemMenu[] = [];
  public textualsMenuItems: ItemMenu[] = [];

  public is_superuser: boolean = false;
  public is_institution: boolean = false;
  public admin_area: string;

  public admin_urls: any[] = [];

  public showBackButton: boolean = false;
  public cycle2Route = "";
  public institutionRoute: string = "/institution";
  public showInstitutionRoute: boolean = false;
  public hideSidebarHeading: boolean = true;
  private subscription = new Subscription();
  private projectId: number;
  public progress = [0, 0, 0];
  public showButton: boolean = false;
  navbarColor = "bg-gradient-primary";
  institutionName: string;
  institutionImgUrl: string = null;
  isEditor = false;
  bases: any[] = [];

  constructor(
    private store: Store<MenuState>,
    private toolbarService: AppToolbarService,
    private projectService: ProjectService,
    private authService: AuthService,
    private location: Location,
    private events: Events,
    private router: Router,
    private ar: ActivatedRoute,
    private modalConfirmationService: ModalConfirmationDialogService,
    private institutionService: InstitutionService,
    private templateService: TemplateService,
    private modalService: NgbModal,
    private planningService: PlanningService
  ) {
    this.mainMenuItems = this.toolbarService.getMenuItems();
    this.activeMenuItem$ = this.toolbarService.activeMenuItem$;
    this.router.events.subscribe(()=> {
      this.isEditor = this.location.path().includes('/document/editor');
    })
    // this.is_institution = this.authService.user.is_institution;
    // this.is_superuser = this.authService.user.is_superuser;
  }

  ngOnInit() {
    this.events.on("projectId").subscribe((projectId: number) => {
      this.projectId = projectId;
      ProjectService.percentageChanged.subscribe(() => {
        this.projectService.getCycles(projectId).subscribe((cycles) => {
          this.progress[0] = this.projectService.calcPercentage({
            1: cycles[1],
          });
          this.progress[1] = this.projectService.calcPercentage({
            2: cycles[2],
          });
          this.progress[2] = this.projectService.calcPercentage({
            3: cycles[3],
          });
          if (this.progress[0] === 33 && this.progress[1] === 33) {
            this.showButton = true;
            this.events.setEditorLabelVisible(true);
          } else {
            this.showButton = false;
            this.events.setEditorLabelVisible(false);
          }
        });
      });
    });
    this.events.on("showBases").subscribe(() => {
      this.updateBases();
    })
    this.events.on("clearBases").subscribe(() => {
      this.bases = [];
    })
    this.menuItems$ = this.store.pipe(select(getAllMenuItems));
    this.adminUrls$ = this.store.pipe(select(getAllAdminUrlsMenuItems));
    this.institutionUrls$ = this.store.pipe(
      select(getAllInstitutionUrlsMenuItems)
    );
    this.isSuperUser$ = this.store.pipe(select(getIsSuperUser));
    this.isInstitutionAdmin$ = this.store.pipe(select(getIsInstitution));
    this.store.dispatch(loadAllMenuItems());

    this.events.on("showBackButton").subscribe((showBackButton: boolean) => {
      setTimeout(() => {
        this.showBackButton = showBackButton;
        if (showBackButton) {
          // this.joyrideService.startTour({
          //   steps: ["firstStep", "secondStep"],
          //   themeColor: "#0099B3",
          //   customTexts: {
          //     next: "Próximo",
          //     prev: "Anterior",
          //     done: "Ok",
          //   },
          // });
        }
      }, 0);
    });

    TemplateService.preTextualsMenuItemsAdded.subscribe((menuItems) => {
      const preTextualsMenuItems = [];
      menuItems.forEach((el) => {
        preTextualsTexts[el[0]] &&
          preTextualsMenuItems.push(
            new PreTextualsMenuItem(
              el[0],
              preTextualsTexts[el[0]],
              preTextualsTextsPositions.indexOf(el[0])
            )
          );
      });
      this.preTextualsMenuItems = preTextualsMenuItems.sort((a, b) =>
        a.position > b.position ? 1 : -1
      );
    });

    TemplateService.textualsMenuItemsAdded.subscribe((menuItems) => {
      this.textualsMenuItems.push(new TextualsMenuItem("content", "Seções", 0));
    });

    TemplateService.posTextualsMenuItemsAdded.subscribe((menuItems) => {
      const posTextualsMenuItems = [];
      menuItems.forEach(
        (el) =>
          posTextualsTexts[el[0]] &&
          posTextualsMenuItems.push(
            new PosTextualsMenuItem(
              el[0],
              posTextualsTexts[el[0]],
              posTextualsTextsPositions.indexOf(el[0])
            )
          )
      );
      this.posTextualsMenuItems = posTextualsMenuItems.sort((a, b) =>
        a.position > b.position ? 1 : -1
      );
    });

    ProjectService.templateAplied.subscribe(
      () => this.mainMenuItems[3] && (this.mainMenuItems[3].disable = false)
    );

    this.router.events
      .pipe(
        tap(() => {
          // setTimeout(() => {
          // @ts-ignore
          if (
            // @ts-ignore
            this.ar.snapshot._routerState.url === "/" ||
            // @ts-ignore
            this.ar.snapshot._routerState.url.includes("repositories")
          ) {
            this.preTextualsMenuItems = [];
            this.posTextualsMenuItems = [];
            this.textualsMenuItems = [];

            // this.mainMenuItems.push(
            //   {icon: 'fa-boxes', path: '/', title: 'Todos projetos', disable: false, hide: true},
            //   {icon: 'fa-user-graduate', path: '/', title: 'Meus Projetos', disable: false, hide: true},
            //   {icon: 'fa-chalkboard-teacher', path: '/my-students', title: 'Orientados por mim', disable: false, hide: true},
            //   {icon: 'fa-bookmark', path: '/reminders', title: 'Lembretes', disable: false, hide: true},
            //   {icon: 'fa-lightbulb', path: '/suggestions', title: 'Sugestões', disable: false, hide: true},
            //   // {icon: 'fa-lightbulb', path: '/invitations', title: 'Convites', disable: false},
            //   {icon: 'fa-language', path: '/translation-page', title: 'Tradução', disable: false, hide: true},
            //   {icon: 'fa-book-open', path: '/manual-page', title: 'Manuais', disable: false},
            // );

            // this.admin_urls.push(
            //   {icon: 'fa-user-cog', path: '/admin/coupons', title: 'Cupons', disable: false},
            //   {icon: 'fa-user-cog', path: '/admin/suggestions', title: 'Sugestões', disable: false},
            //   {icon: 'fa-user-cog', path: '/admin/partnerships', title: 'Solicitações parceria', disable: false},
            //   {icon: 'fa-user-cog', path: '/admin/users', title: 'Usuários', disable: false}
            // );
          }

          // Events.myProjectsDidCount.subscribe((total: number) => {
          //   this.mainMenuItems[1].totalProjects = total;
          // });

          // Events.myProjectsStudentDidCount.subscribe((total: number) => {
          //   this.mainMenuItems[2].totalOriented = total;
          // });
          // }, 200);
        }),
        filter(
          (e: ActivatedRoute) =>
            e !== null &&
            e.snapshot !== undefined &&
            e.snapshot.params !== undefined
        ),
        filter((e: ActivatedRoute) => e.snapshot.params.id !== undefined)
      )
      .subscribe((val: ActivatedRoute) => {
        const locationPath = this.location.path();
        if (
          locationPath.includes("/project") &&
          !locationPath.includes("repositories")
        ) {
          // this.mainMenuItems = [];
          this.preTextualsMenuItems = [];
          this.posTextualsMenuItems = [];
          this.textualsMenuItems = [];

          if (!locationPath.includes("/document")) {
            const template = ProjectService.getTemplate();
          }
        }
      });

      if (!this.authService.user) {
        this.events.on("profile").subscribe((profile: Profile) => {
          this.institutionService.getInstitutionByName(
            profile.student_institution.info.affiliation.name
          ).subscribe(res => {
            if (!res.url_image) return;
            this.templateService.getBase64Image({ url: res.url_image }).subscribe(res => {
              if (!res) {
                this.institutionImgUrl = null;
                return;
              }
              this.institutionImgUrl = "data:image/jpeg;base64," + res;
            })
          });
        })
      } else {
        this.institutionService.getInstitutionByName(
          this.authService.user.student_institution.info.affiliation.name
        ).subscribe(res => {
          if (!res.url_image) return;
          this.templateService.getBase64Image({ url: res.url_image }).subscribe(res => {
            if (!res) {
              this.institutionImgUrl = null;
              return;
            }
            this.institutionImgUrl = "data:image/jpeg;base64," + res;
          })
        });
      }
  }
  toggleSelected(item: ItemMenu) {
    // Primeiro, desmarca todos os itens
    this.preTextualsMenuItems.forEach(i => i.selected = false);
    // Em seguida, marca o item clicado
    item.selected = true;
 }

 toggleAndFetch(item: ItemMenu): void {
  this.toggleSelected(item);
  item.fetchContent();
}

  onStepDone() {
    this.events.broadcast("editorNextStep");
  }

  updateBases() {
    this.bases = [];
    this.planningService
      .getProtocol(this.projectId)
      .subscribe((protocol: Protocol) => {
        protocol.protocol_fonts.forEach((source) => {
          source.development_search_strings.forEach((search_string, index) => {
            const sourceIndex = protocol.protocol_fonts.map((el) => el.id).indexOf(search_string.protocol_font_id);
            this.bases.push({
              id: search_string.id,
              name: `${protocol.protocol_fonts[sourceIndex].setting_protocol.font} - ${search_string.listing_order}`,
            });
          })
        });
    });
  }

  back() {
    // this.modalConfirmationService
    //   .confirm(
    //     "",
    //     `Deseja exportar o documento em PDF?`,
    //     "SIM",
    //     "NÃO",
    //     "sm",
    //     "modal-confirmation-dialog"
    //   )
    //   .then((confirmed) => {
    //     if (confirmed) {
    //       this.events.broadcast("downloadPdf", {
    //         confirmBack: true,
    //         projectName: this.projectService.getName(),
    //       });
    //     } else {
    //       }
    //   })
    //   .catch(() => {});
      const urlParts = this.router.routerState.snapshot.url.split("/");
      const projectId = urlParts[2];
      this.router.navigateByUrl(`projects/${projectId}/development`);
   
  }

  importStudiesLabelsClick(evt) {
    const value = evt.target.control.defaultValue;

    this.events.setEditorStatusLabel(value);

    this.subscription.add(
      this.projectService
        .updateProgress(this.projectId, {
          cycle: 3,
          step: {
            name: "writing",
            status: value,
          },
        })
        .subscribe(() => {
          this.projectService.setNavbarPercentage();
        })
    );
  }

  backClicked() {
    this.location.back();
  }

  openViewBibtexModal(searchStringId: number, name: string) {
    const modalRef = this.modalService.open(ModalViewBibtexComponent)
    modalRef.componentInstance.searchStringId = searchStringId
    modalRef.componentInstance.name = name
  }

  checkContext(itemTitle: string): boolean {
    return this.menuTexts.includes(itemTitle);
  }

  ngAfterViewChecked() {
    const handlerBtnPlan = (_ev) => {
      const events = {
        add(classList) {
          classList.add("btn-plan-min");
        },
        remove(classList) {
          classList.remove("btn-plan-min");
        },
      };
      const btnPlan = document.querySelector(".btn-plan");
      if (btnPlan) {
        const handler = events[_ev];
        handler(btnPlan.classList);
      }
    };

    const handleBadges = (evt) => {
      const events = {
        add(classList) {
          classList.add("pos");
        },
        remove(classList) {
          classList.remove("pos");
        },
      };
      const badges = document.querySelectorAll(".badge-sidebar");
      if (badges.length) {
        badges.forEach((el) => {
          const handler = events[evt];
          handler(el.classList);
        });
      }
    };

    if ($(".sidebar").width() < 100) {
      handleBadges("remove");
      handlerBtnPlan("add");
    }

    $(window).resize(function () {
      if ($(".sidebar").width() > 100) {
        handleBadges("add");
        handlerBtnPlan("remove");
      } else {
        handleBadges("remove");
        handlerBtnPlan("add");
      }
    });
  }

  hideMenu() {
    return true;
  }
}
